import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PackagingSlipState } from "@tKgpco/Store/Data/PackagingSlips/PackagingSlipsState";
import { Draft } from "immer";

const initialState: PackagingSlipState = {
    isLoading: false,
    packagingSlips: [],
};
export const reducer = {
    "Custom/OrderHistoryPackagingSlips/BeginLoad": (draft: Draft<PackagingSlipState>) => {
        draft.isLoading = true;
    },
    "Custom/OrderHistoryPackagingSlips/CompleteLoad": (
        draft: Draft<PackagingSlipState>,
        action: PackagingSlipState,
    ) => {
        draft.isLoading = false;
        draft.packagingSlips = action.packagingSlips;
    },
    "Custom/OrderHistoryPackagingSlips/FailedToLoadPackagingSlips": (draft: Draft<PackagingSlipState>) => {
        draft.isLoading = false;
        draft.packagingSlips = [];
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
